import RadioContext from "./RadioContext";

function RadioGroup({ label, children, ...rest }) {
  return (
    <fieldset>
      <h2>{label}</h2>
      <RadioContext.Provider value={rest}>{children}</RadioContext.Provider>
    </fieldset>
  );
}

export default RadioGroup;